import style from './PrivacyPolicy.module.scss';
import React from 'react';

function PrivacyPolicy() {
  return (
    <div className={style.container}>
      <h1 className={style.title}>PRIVACY POLICY</h1>
      <h2 className={style.subtitle}>
        Sunshine Life &amp; Health Advisors LLC
      </h2>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>1. WHO WE ARE</h3>
        <p className={style.paragraph}>
          Sunshine Life &amp; Health Advisors LLC (&quot;Sunshine Life &amp;
          Health,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) is a
          field-marketing organization that recruits, contracts, and supports
          licensed insurance agents. We do not sell insurance products directly
          to retail consumers. This Privacy Policy explains how we collect, use,
          and protect information through our mobile application (available on
          iOS and Android), our agent web portal, and our related digital
          services (collectively, the &quot;Services&quot;).
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>2. SCOPE</h3>
        <p className={style.paragraph}>This Privacy Policy applies to:</p>
        <ul className={style.list}>
          <li>
            The Sunshine Portal app, available on the Apple App Store (iOS) and
            Google Play Store (Android);
          </li>
          <li>The Sunshine Life &amp; Health agent web portal; and</li>
          <li>
            Any related websites, microsites, or landing pages that link to this
            Policy.
          </li>
        </ul>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>3. INFORMATION WE COLLECT</h3>
        <p className={style.paragraph}>
          <strong>Information you provide directly:</strong>
        </p>
        <ul className={style.list}>
          <li>Full name, email address, phone number, and mailing address</li>
          <li>
            National Producer Number (NPN), insurance license number(s), and
            state(s) of licensure
          </li>
          <li>
            Agency name, lines of authority, carrier appointments, and
            commission preferences
          </li>
          <li>
            Any documents or forms submitted through the Services for
            contracting or compliance purposes
          </li>
        </ul>
        <p className={style.paragraph}>
          <strong>Information collected automatically:</strong>
        </p>
        <ul className={style.list}>
          <li>
            Device information, including device type, operating system version,
            and unique device identifiers (iOS/Android)
          </li>
          <li>
            App usage data, including screens viewed, features used, session
            duration, and in-app actions
          </li>
          <li>IP address, browser type, and referring URLs (web portal)</li>
          <li>
            Push notification tokens (if you grant permission on your mobile
            device)
          </li>
          <li>Crash logs and performance diagnostics</li>
        </ul>
        <p className={style.paragraph}>
          We do not intentionally collect personal information from consumers
          seeking insurance coverage.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>4. HOW WE USE YOUR INFORMATION</h3>
        <p className={style.paragraph}>We use the information we collect to:</p>
        <ul className={style.list}>
          <li>
            Verify licensure and complete agent contracting and onboarding
            paperwork
          </li>
          <li>
            Create and manage your account on the agent web portal and mobile
            application
          </li>
          <li>
            Deliver push notifications, in-app messages, and email
            communications relevant to your contracting status, carrier
            appointments, or compliance requirements
          </li>
          <li>Respond to support requests, questions, or compliance matters</li>
          <li>
            Send operational or marketing communications — only where you have
            opted in or another lawful basis applies. You may opt out at any
            time
          </li>
          <li>
            Monitor, improve, and secure the mobile application and web portal
            through analytics and performance monitoring
          </li>
          <li>
            Comply with applicable insurance regulations and legal obligations
          </li>
        </ul>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>
          5. MOBILE APPLICATION — ADDITIONAL DISCLOSURES
        </h3>
        <p className={style.paragraph}>
          When you use our iOS or Android application, the following additional
          practices apply:
        </p>
        <ul className={style.list}>
          <li>
            <strong>Permissions:</strong> We may request access to push
            notifications, and storage, depending on features you use.
          </li>
          <li>
            <strong>Push Notifications:</strong> With your consent, we send push
            notifications about contracting updates, compliance deadlines, and
            important announcements. You may disable push notifications through
            your device settings at any time.
          </li>
          <li>
            <strong>Analytics:</strong> We use mobile analytics tools to
            understand how agents use the app and to fix bugs and improve
            performance. These tools may collect anonymized usage data.
          </li>
          <li>
            <strong>App Store Platforms:</strong> Your download and use of the
            application is also subject to Apple&apos;s App Store or Google Play
            terms and privacy policies, as applicable.
          </li>
        </ul>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>6. COOKIES AND ANALYTICS</h3>
        <p className={style.paragraph}>
          On the agent web portal, we use first-party cookies and third-party
          analytics tools to understand how users navigate the portal and to
          protect against unauthorized access. You can manage cookie preferences
          through your browser settings; however, disabling cookies may affect
          certain portal functionality.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>7. LEGAL GROUNDS FOR PROCESSING</h3>
        <p className={style.paragraph}>
          We process personal information on the following legal grounds:
        </p>
        <ul className={style.list}>
          <li>
            <strong>Consent</strong> — for example, when you sign up for
            notifications or marketing communications
          </li>
          <li>
            <strong>Performance of a contract</strong> — for example, processing
            your carrier appointment or granting portal/app access
          </li>
          <li>
            <strong>Legitimate interests</strong> — for example, operating,
            securing, and improving our Services
          </li>
          <li>
            <strong>Legal and regulatory compliance</strong> — for example,
            maintaining records required by state insurance departments
          </li>
        </ul>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>8. SHARING YOUR INFORMATION</h3>
        <p className={style.paragraph}>
          We share personal information only with:
        </p>
        <ul className={style.list}>
          <li>
            Insurance carriers and uplines involved in your contracting and
            appointment process
          </li>
          <li>
            Service providers who assist us in hosting the application and
            portal, sending communications, or analyzing performance — all of
            whom are bound by confidentiality obligations
          </li>
          <li>
            Government or regulatory bodies when required by law, court order,
            or regulatory authority
          </li>
        </ul>
        <p className={style.paragraph}>
          We do not sell your personal information.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>9. YOUR PRIVACY RIGHTS</h3>
        <p className={style.paragraph}>
          Depending on your state of residence, you may have the right to:
        </p>
        <ul className={style.list}>
          <li>Access the personal information we hold about you</li>
          <li>Correct inaccurate or incomplete information</li>
          <li>
            Request deletion of your personal information, subject to certain
            exceptions
          </li>
          <li>Limit or object to certain uses of your data</li>
          <li>Appeal a decision if we decline to fulfill a request</li>
        </ul>
        <p className={style.paragraph}>
          To exercise any of these rights, please contact us at{' '}
          <a href='mailto:sunshine.support@westondev.com'>
            sunshine.support@westondev.com
          </a>
          . We will respond within the timeframe required by applicable law (for
          example, within 45 days for California residents under the CCPA).
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>10. SECURITY</h3>
        <p className={style.paragraph}>
          We implement administrative, technical, and physical safeguards to
          protect your information, including TLS/SSL encryption for data in
          transit, access controls and authentication requirements for the
          portal and mobile application, and periodic security reviews. While we
          take these measures seriously, no system is completely secure, and we
          cannot guarantee absolute security.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>11. INTERNATIONAL VISITORS</h3>
        <p className={style.paragraph}>
          Our Services are operated in the United States. If you access the
          Services from outside the United States, please be aware that your
          information will be transferred to and processed in the United States,
          where privacy laws may differ from those in your jurisdiction.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>12. RETENTION</h3>
        <p className={style.paragraph}>
          We retain personal information for as long as necessary to maintain
          active agent contracts, satisfy legal and regulatory retention
          requirements, resolve disputes, and enforce agreements. When
          information is no longer needed, we securely delete or anonymize it.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>13. CHILDREN&apos;S PRIVACY</h3>
        <p className={style.paragraph}>
          Our Services are intended for licensed insurance professionals and are
          not directed to individuals under the age of 18. We do not knowingly
          collect personal information from minors.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>14. CHANGES TO THIS POLICY</h3>
        <p className={style.paragraph}>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or applicable law. Any material changes will be
          posted here with an updated effective date. We encourage you to review
          this Policy periodically.
        </p>
      </div>

      <div className={style.section}>
        <h3 className={style.sectionTitle}>15. CONTACT US</h3>
        <p className={style.paragraph}>
          If you have questions or concerns about this Privacy Policy or our
          data practices, please contact us:
        </p>
        <p className={style.paragraph}>
          Sunshine Life &amp; Health Advisors LLC
          <br />
          7757 W Flagler St, Suite 210
          <br />
          Miami, FL 33144 (Inside Midway Crossings Mall)
        </p>
        <p className={style.paragraph}>
          Phone: 800-390-1730
          <br />
          Email:{' '}
          <a href='mailto:sunshine.support@westondev.com'>
            sunshine.support@westondev.com
          </a>
          <br />
          Hours: Monday–Friday, 8:30 AM – 5:00 PM EST
        </p>
      </div>

      <p className={style.lastUpdated}>
        This Privacy Policy was last updated on April 10, 2025.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
